import React from "react";
import { FaAward, FaUsers } from "react-icons/fa"; // React icons for Award & Team
import "../Aboutus/Award.css";

const Award = () => {
  return (
    <div className="full-design-container">
      {/* Left Image Section */}
      <div className="image-section">
        <img src="award.webp" alt="Gardening" className="gardening-image" />
      </div>

      {/* Content Section */}
      <div className="content-section">
        <h1 className="experience-years">
          10 <span className="subtext">Years of Experience</span>
        </h1>
        <h2 className="main-title">We Make Your Home Like A Garden</h2>
        <p className="description-a">
          With unmatched expertise, we transform homes into green havens,
          offering innovative gardening solutions tailored to your needs.
        </p>

        {/* Features Section */}
        <div className="features">
          <div className="feature-item">
            <FaAward className="feature-icon" />
            <h3 className="feature-title">Award Winning</h3>
            <p className="feature-description">
              Recognized for excellence in creating sustainable, breathtaking
              landscapes that inspire and impress.
            </p>
          </div>
          <div className="feature-item">
            <FaUsers className="feature-icon" />
            <h3 className="feature-title">Dedicated Team</h3>
            <p className="feature-description">
              A passionate and skilled team devoted to bringing your gardening
              vision to life with care and precision.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Award;
